export default "__VITE_ASSET__D5GT87oH__"